import { Form } from 'antd'
import HelpIcon from 'components/HelpIcon'
import FieldControl from './components/FieldControl'
import type { ConfiguredFieldsProps } from './types'
import { required } from './utils'

/** Renders all enabled configured fields while retaining hidden form values. */
function ConfiguredFields({
  errors,
  fields,
  formId,
  onBlur,
  onChange,
  payItems,
  pending,
  values,
}: ConfiguredFieldsProps) {
  return (
    <>
      {fields.map((field) => {
        const controlId = `${formId}-field-${field.id}`
        const errorId = `${controlId}-error`
        const error = errors[field.id]?.join(' ')
        const hidden = field.readOnly?.hideFieldValue === true

        return (
          <Form.Item
            colon={!!field.name}
            help={error ? <span id={errorId}>{error}</span> : undefined}
            htmlFor={controlId}
            hidden={hidden}
            key={field.id}
            label={<HelpIcon text={field.tooltip}>{field.name}</HelpIcon>}
            required={required(field)}
            validateStatus={error ? 'error' : undefined}
          >
            {!hidden && (
              <FieldControl
                accessibility={{
                  id: controlId,
                  'aria-describedby': error ? errorId : undefined,
                  'aria-invalid': !!error,
                  'aria-required': required(field),
                }}
                disabled={pending || field.readOnly !== null}
                field={field}
                onBlur={() => onBlur(field.id)}
                onChange={(value) => onChange(field.id, value)}
                payItems={payItems}
                value={values[field.id]}
              />
            )}
          </Form.Item>
        )
      })}
    </>
  )
}

export default ConfiguredFields
